import { RouteRecordRaw } from 'vue-router';
import { useCompanyStore, useCreativeStore } from '@/common/store';

const creativeRoutes: RouteRecordRaw[] = [
  {
    path: 'creatives',
    name: 'CreativesView',
    redirect: { name: 'CompaniesListView' },
    meta: { menu: 'creative' },
    component: () => import(/* webpackChunkName: "CreativesView" */ '@/views/creatives/CreativesView.vue'),
    beforeEnter: async () => {
      const companyStore = useCompanyStore();
      await companyStore.checkCompanyId();
    },
    children: [
      {
        path: '',
        name: 'CreativesListView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativesListView" */ '@/views/creatives/CreativesListView.vue'),
        beforeEnter: () => {
          const creativeStore = useCreativeStore();
          creativeStore.resetParentFolders();
        },
      },
      {
        path: 'analytics',
        name: 'CreativesAnalyticsView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativesAnalyticsView" */ '@/views/creatives/CreativesAnalyticsView.vue'),
      },
      {
        path: 'analytics/:id',
        name: 'CreativesAnalyticsDetailsView',
        props: true,
        meta: { hideSidebar: true },
        component: () => import(/* webpackChunkName: "CreativesAnalyticsDetailsView" */ '@/views/creatives/CreativesAnalyticsDetailsView.vue'),
      },
      {
        path: 'templates',
        name: 'CreativeTemplatesView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativeTemplatesView" */ '@/views/creatives/CreativeTemplatesView.vue'),
      },
      {
        path: 'favorites',
        name: 'CreativesFavoritesView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativesFavoritesView" */ '@/views/creatives/CreativesFavoritedView.vue'),
      },
      {
        path: 'archived',
        name: 'CreativesArchivedView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativesArchivedView" */ '@/views/creatives/CreativesArchivedView.vue'),
      },
      {
        path: 'deleted',
        name: 'CreativesDeletedView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativesDeletedView" */ '@/views/creatives/CreativesDeletedView.vue'),
      },
      {
        path: 'play/:id',
        name: 'PlayEditView',
        props: true,
        meta: { hideSidebar: true },
        component: () => import(/* webpackChunkName: "PlayView" */ '@/views/creatives/PlayView.vue'),
        beforeEnter: () => {
          const creativeStore = useCreativeStore();
          creativeStore.historyMode = false;
        },
      },
      {
        path: 'play/:id/history/:historyId',
        name: 'PlayHistoryView',
        props: true,
        meta: { hideSidebar: true },
        component: () => import(/* webpackChunkName: "PlayView" */ '@/views/creatives/PlayView.vue'),
        beforeEnter: () => {
          const creativeStore = useCreativeStore();
          creativeStore.historyMode = true;
        },
      },
      {
        path: 'canvas/:id',
        name: 'CanvasEditView',
        props: true,
        meta: { hideSidebar: true },
        component: () => import(/* webpackChunkName: "CanvasView" */ '@/views/creatives/CanvasView.vue'),
      },
      {
        path: 'folder/:id',
        name: 'CreativeListInFolderView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CreativesFoldersView" */ '@/views/creatives/CreativesFoldersView.vue'),
      },
      {
        path: 'templated/:id',
        name: 'CreativeV1View',
        meta: { hideSidebar: true },
        component: () => import(/* webpackChunkName: "CreativeV1Editor" */ '@/views/creatives/CreativeV1Editor.vue'),
      },
    ],
  },
];

export default creativeRoutes;
